import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/system";

import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

export default function YotoInitialConfiguration() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{
        fontWeight: 600
      }}>
        Configurare inițială (o singură dată)
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            <Box
              sx={{
                bgcolor: "yoto.main",
                color: "white",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              1
            </Box>
          </ListItemIcon>
          <ListItemText primary="Deschide aplicația Yoto pe telefon" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Box
              sx={{
                bgcolor: "yoto.main",
                color: "white",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              2
            </Box>
          </ListItemIcon>
          <ListItemText primary="Mergi la Library → Playlists" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Box
              sx={{
                bgcolor: "yoto.main",
                color: "white",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              3
            </Box>
          </ListItemIcon>
          <ListItemText primary='Găsește "Cântecelul Meu" și apasă "Link to a card"' />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Box
              sx={{
                bgcolor: "yoto.main",
                color: "white",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              4
            </Box>
          </ListItemIcon>
          <ListItemText primary="Atinge cartonașul fizic Yoto pentru a-l asocia" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Box
              sx={{
                bgcolor: "yoto.main",
                color: "white",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              <CheckCircleIcon color="inherit" />
            </Box>
          </ListItemIcon>
          <ListItemText primary="Gata! Cartonașul se va actualiza automat cu orice cântec nou" />
        </ListItem>
      </List>
    </Box>
  );
}
